import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import axios from './request'
import * as echarts from 'echarts'
import './assets/style/index.less'

import {registerGlobalFunction} from './utils'

registerGlobalFunction(Vue)

import WotDesign from 'wot-design'
import 'wot-design/lib/theme-default/index.css'

Vue.use(WotDesign)

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI)

import Vant from 'vant'
import 'vant/lib/index.css'

Vue.use(Vant)

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.prototype.$moment = moment
Vue.prototype.$goBack = () => {
    router.go(-1)
}

Vue.prototype.$goHome = () => {
    router.push('/home')
}

const app = new Vue({
    router,
    render: (h) => h(App),
})

app.$mount('#app')


// 加入百度统计
var _hmt = _hmt || [];
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?" + "835875137653ac0d57b30133962b8739";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    next()
})